export const SYSTEM_DISPLAY_NAMES = {
  Identity: 'Cloud Portal',
  ContentService: 'Content Service',
  CDP: 'Personalize / CDP',
  Connect: 'Connect',
  SupportLogin: 'Support Login',
};

export type AuditLogsSupportedSystemName = keyof typeof SYSTEM_DISPLAY_NAMES;
